import styled from 'styled-components';

import Spinner from './Spinner';

export default styled(Spinner)`
  .spinner {
    animation: rotate 1.5s infinite linear;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    height: 40px;
    width: 40px;

    svg {
      height: 100%;
      width: 100%;
    }

    &__backdrop {
      background: rgba(24, 42, 51, 0.34);
      bottom: 0;
      left: 0;
      position: fixed;
      right: 0;
      top: 0;
      z-index: 99;
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`;
